import { useEffect, useState } from 'react'
import { useAppDispatch } from '@/utils/typeHelpers'
import { selectEmployeeByUuid } from '../payroll.selectors'
import { fetchAllEmployeeForms } from '../payrollActions'
import { GustoFormsTable } from '../payroll-documents/GustoFormsTable'
import { Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { Gusto_GustoForm } from '../generated_gusto_types'
import { TypographyStyles } from '@/styles'

export const EmployeeDocumentsTab = ({ uuid }: { uuid: string }) => {
  const dispatch = useAppDispatch()
  const employee = useReselector(selectEmployeeByUuid, uuid)

  const [forms, setForms] = useState<Gusto_GustoForm[]>([])

  useEffect(() => {
    const fetchForms = async () => {
      const res = await fetchAllEmployeeForms(uuid)(dispatch)
      if (res) {
        setForms(res)
      }
    }

    fetchForms()
  }, [dispatch, uuid])

  if (!employee) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      <Text variant={TypographyStyles.H2} className="pt-4">
        Employee Documents
      </Text>
      <Text className="my-2]">
        These are documents shared between you and{' '}
        <b>
          {employee.first_name} {employee.last_name}
        </b>
      </Text>

      <GustoFormsTable forms={forms} employeeUuid={uuid} />
    </div>
  )
}
